

@if (isLoading === false) {
  <div mat-dialog-title>
    <h2>{{mindmapTitle}}</h2>
    <button class="close"
      (click)="close()"
      aria-label="Close dialog">
      <mat-icon svgIcon="cross"></mat-icon>
    </button>
  </div>
  <mat-dialog-content [innerHTML]="text"></mat-dialog-content>
} @else {
  <mat-spinner></mat-spinner>
}